module.exports = __webpack_public_path__ + "static/media/circulo_A46B00.d22e166d.svg";